.wrapper {
  overflow-y: auto;
}

.wrapper::-webkit-scrollbar {
  width: 1rem;
}

.wrapper::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--ttui_grey-700), transparent 50%);
  border-right: 0.25rem solid transparent;
  border-left: 0.25rem solid transparent;
  border-radius: 0.45rem;
  background-clip: content-box;
}

.wrapper * {
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

.shared3dDiceContainer {
  display: flex;
  padding: 1rem 1.875rem;
  align-items: center;
  position: relative;
}

.shared3dDiceContainer::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 1.875rem;
  right: 1.875rem;
  height: 0.0625rem;
  background: color-mix(in srgb, var(--ttui_grey-700), transparent 15%);
}

.shared3dDiceImageWrapper {
  position: relative;
  width: 4rem;
  height: 4rem;
  flex-shrink: 0;
  margin-right: 0.5rem;
  pointer-events: none;
}

.shared3dDiceImage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.shared3dDiceImageDisabled {
  opacity: 0.5;
}

.diceTextContainer {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.diceSetLabel {
  bottom: calc(100% + 0.25rem);
  color: var(--ttui_grey-500);
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 8.625rem;
}

.changeDiceSetLink {
  color: var(--ttui_common-0);
  display: flex;
  align-items: center;
}

.changeDiceSetLink svg {
  fill: var(--ttui_common-0);
  width: 0.75rem;
  height: 0.75rem;
  margin-left: 0.5rem;
}

.refreshText {
  font-size: 0.625rem;
  font-style: italic;
  color: var(--ttui_grey-500);
  white-space: nowrap;
  top: calc(100% + 0.75rem);
}

.toggleSwitchContainer {
  width: 3.5rem;
  margin-left: auto;
}

.diceContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1rem 1.875rem;
  width: 20.375rem;
}

.dice {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  row-gap: 1rem;
  margin-bottom: 0.5rem;
}

.buttonsWrapper {
  width: 100%;
  display: flex;
  gap: 0.5rem;
}

.rollButton,
.clearButton {
  justify-content: center;
  width: 50%;
  height: 2rem;
  border-radius: 0.5rem;
  font-weight: bold;
  letter-spacing: 0.063rem;
  transition: none;
}

.rollButton.rollButton {
  background: var(--ttui_red-500);
  border-color: var(--ttui_red-500);
  color: var(--ttui_common-0);
}

.rollButton.rollButton:hover {
  background: var(--ttui_red-700);
  border-color: var(--ttui_red-700);
}

.clearButton {
  background: var(--ttui_common-0);
  color: var(--ttui_grey-800);
}

.clearButton:hover {
  background: var(--ttui_grey-200);
}

.rollButton[disabled],
.clearButton[disabled] {
  pointer-events: none;
  opacity: 0.3;
}

.rollToWrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin: 0.5rem 1.125rem 0 0;
}

.rollToContainer {
  display: flex;
  background: color-mix(in srgb, var(--ttui_grey-900), transparent 15%);
  border-radius: 0.5rem;
  padding: 0.25rem;
  box-shadow: var(--ttui_box-shadow-1);
  column-gap: 0.125rem;
}

.rollToButton {
  background: none;
  box-shadow: none;
  color: var(--ttui_grey-800);
  border: 0.125rem solid transparent;
  height: 1.5rem;
  border-radius: 0.5rem;
}

.rollToButton:has(svg:only-child) {
  padding: 0.375rem 0.25rem;
}

.rollToButton svg:only-child {
  height: 0.75rem;
  fill: var(--ttui_grey-500);
}

.rollToButton:hover {
  background: color-mix(in srgb, var(--ttui_grey-600), transparent 70%);
  color: var(--ttui_grey-400);
}

.rollToActive,
.rollToActive:hover {
  background: var(--ttui_grey-600);
}

.rollToActive:has(svg:only-child) {
  border-color: var(--ttui_grey-600);
}

.rollToActive svg:only-child {
  fill: var(--ttui_common-0);
}

.rollToLabel {
  font-size: 0.75rem;
  font-style: italic;
  margin: 0 auto 0 0.625rem;
  color: var(--ttui_grey-500);
}

.die,
.die:hover {
  background: none;
}

.die.die {
  box-shadow: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 4rem;
  text-transform: none;
  color: var(--ttui_grey-400);
  padding: 0 0.625rem;
  line-height: 1;
  position: relative;
  border: 0.125rem solid transparent;
  transition: none;
  border-radius: 0.5rem;
  font-size: 0.938rem;
  font-weight: bold;
  gap: unset;
}

.die.die svg {
  fill: var(--ttui_common-0);
}

.die .plus {
  opacity: 0;
  position: absolute;
  top: 0.813rem;
  width: 1rem;
  height: 1rem;
  stroke: var(--ttui_grey-600);
  stroke-width: 4rem;
  paint-order: stroke;
}

.die:hover {
  background: color-mix(in srgb, var(--ttui_grey-600), transparent 20%);
}

.die:hover .plus {
  opacity: 1;
}

.die:hover svg:first-of-type {
  opacity: 0.2;
}

.die span {
  margin-top: 0.375rem;
}

.die svg {
  width: 2rem;
  height: 2rem;
}

.die svg:has(+ span) {
  margin-right: 0;
}

.die[data-quantity] {
  background: var(--ttui_grey-300);
  color: var(--ttui_grey-700);
  border: 0.125rem solid var(--ttui_common-0);
}

.die[data-quantity]::after {
  content: attr(data-quantity);
  position: absolute;
  top: -0.625rem;
  left: 50%;
  transform: translateX(-50%);
  color: var(--ttui_common-0);
  background: var(--ttui_common-1000);
  border-radius: 50%;
  padding: 0.125rem 0.25rem;
  line-height: 1;
  border: 0.125rem solid var(--ttui_common-0);
  font-size: 0.75rem;
  letter-spacing: 0;
  font-weight: 400;
}

.die[data-quantity] svg,
.die[data-quantity]:hover svg,
.die[data-quantity] .d100 {
  opacity: 1;
  fill: var(--ttui_grey-900);
}

.die[data-quantity] .plus {
  display: none;
}

.die:has(svg:only-child) {
  padding: 0;
}

.d20 {
  margin-left: 0;
}

.d100 svg {
  width: 100%;
}

.d10 {
  margin-right: 0;
}

.d8 {
  margin-left: 2.375rem;
}

.d4 {
  margin-right: 2.375rem;
}
